import { Coins } from "lucide-react";
import Flag from "react-world-flags";

import { cn } from "@/shared/lib/utils";

import { CURRENCY_TO_DISPERSION_CODE, CURRENCY_TO_FLAG_CODE } from "../constants/wallets.constants";

/** The flag a wallet card shows for a currency: its own, else its country's; coins for a crypto one. */
export function CurrencyFlag({ currency, size = "sm" }: { currency: string; size?: "sm" | "md" }) {
  const code = CURRENCY_TO_FLAG_CODE[currency] ?? CURRENCY_TO_DISPERSION_CODE[currency] ?? null;
  return code ? (
    <Flag
      code={code}
      className={cn(
        "shrink-0 object-cover",
        size === "md" ? "h-5 w-7 rounded-[3px] shadow-sm" : "h-3 w-[18px] rounded-[2px]",
      )}
      aria-hidden
    />
  ) : (
    <Coins
      className={cn("shrink-0 text-muted-foreground", size === "md" ? "size-5" : "size-3.5")}
      aria-hidden="true"
    />
  );
}
